import React, { useState, useEffect } from 'react';
import {
  Form, Row, Input, Col, Icon, Checkbox,
} from 'antd';
import PropTypes from 'prop-types';
import './PushNotificationForm.less';

const { TextArea } = Input;

const PushNotification = (props) => {
  const [checked, setChecked] = useState(false);

  // Checkbox handler change
  const handleChange = (e) => {
    e.preventDefault();
    setChecked(!checked);
  };

  const { form, handleRequest, pushNotificationData } = props;

  const { validateFields, getFieldDecorator, setFieldsValue } = form;

  /**
   * This method handles the form submission, validates it and then
   * sent to the parent container via handleRequest prop method
   * @param {*} e
   */
  function handleSubmit(e) {
    e.preventDefault();
    // If push notification is active gg.
    validateFields((err, values) => {
      if (!err) {
        const data = { ...values };
        handleRequest(data);
      } else {
        handleRequest({ error: true });
      }
    });
  }

  /**
   * UseEffect when pushNotification has data to edit.
   */
  useEffect(() => {
    if (pushNotificationData) {
      const data = { ...pushNotificationData };
      const { title, content, segment } = data;
      data.to_send = false;
      setFieldsValue({
        title,
        content,
        segment,
      });
      handleRequest(data);
    }
  }, [pushNotificationData]);

  return (
    <div className="push-notification-form">
      <Form onSubmit={handleSubmit} onBlur={handleSubmit}>
        <Row gutter={20}>
          <Col span={24}>
            <h2 className="form-title">Push Notification</h2>
          </Col>
          <Col span={24}>
            <Form.Item label="Título">
              {getFieldDecorator('title', {
                rules: [
                  {
                    max: 50,
                    message: 'Caracteres excedidos.',
                    type: 'string',
                  },
                  {
                    required: true,
                    message: 'Por favor inserte el Título',
                  },
                ],
              })(<Input suffix={<Icon type="smile" className="smile-icon" />} placeholder="Playa del Carmen" />)}
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Mensaje">
              {getFieldDecorator('content', {
                rules: [
                  {
                    max: 250,
                    message: 'Caracteres excedidos.',
                    type: 'string',
                  },
                  {
                    required: true,
                    message: 'Por favor inserte el Mensaje',
                  },
                ],
              })(<TextArea rows={6} placeholder="Vuelo redondo" className="push-text-area" />)}
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Segmento">
              {getFieldDecorator('segment', {
                rules: [
                  {
                    required: true,
                    message: 'Por favor inserte el Segmento',
                  },
                ],
              })(<Input placeholder="dest-cancun" />)}
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item>
              {getFieldDecorator('to_send', {
                initialValue: false,
              })(
                <Checkbox checked={checked} onChange={handleChange}>
                  <b>¿Enviar Push Notification?</b>
                </Checkbox>,
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

PushNotification.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.object.isRequired,
  handleRequest: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  pushNotificationData: PropTypes.object,
};

PushNotification.defaultProps = {
  pushNotificationData: {},
};

const PushNotificationForm = Form.create({ name: 'PushNotification' })(PushNotification);

export default PushNotificationForm;
